import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid'
import Skeleton from '@material-ui/lab/Skeleton';

import Version from '../../api/Version';
import Header from '../../components/utils/Header';
import VersionForm from './VersionForm';


@observer
class VersionEditView extends React.Component {
  static propTypes = {
    instanceId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    Version.removeFromCache(props.instanceId);
    this.instance = Version.getForId(props.instanceId);
  }

  render() {
    if (!this.instance.isLoaded) {
      return <Skeleton variant="rect" height={650} />;
    }
    return (
      <Grid container direction="column" spacing={2} wrap="nowrap">
        <Grid item>
          <Header title={this.instance.toString()} />
        </Grid>
        <Grid item>
          <VersionForm instance={this.instance} />
        </Grid>
      </Grid>
    );
  }
}


export default VersionEditView;
